import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b6a7b8de&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a7b8de')) {
      api.createRecord('b6a7b8de', component.options)
    } else {
      api.reload('b6a7b8de', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b6a7b8de&", function () {
      api.rerender('b6a7b8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/comp/FavElement.vue"
export default component.exports